export enum TransferOrderStatus {
  Draft = "DRAFT",
  Unfulfilled = "UNFULFILLED",
  PartiallyFulfilled = "PARTIALLY_FULFILLED",
  Fulfilled = "FULFILLED",
  PartiallyReceived = "PARTIALLY_RECEIVED",
  Complete = "COMPLETE",
}
